const ITEMS = [
  "Certified Natural Diamonds",
  "GIA · IGI · HRD",
  "JLT — Dubai",
  "0.30ct — 15.00ct+",
  "Conflict-Free Sourcing",
  "Bespoke Acquisitions",
  "Wholesale & Trade Only",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="hairline overflow-hidden border-y bg-[#0E0E10] py-5"
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display px-8 text-xl font-light italic tracking-wide text-[#B8BCC2]">
                {item}
              </span>
              <span className="text-[10px] text-[#C9A24B]">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
